<template>
  <div>
    <!-- {{fuelData}} -->
    <!-- {{fuelStore.data[location]}} -->
    
    <BasicTableComponent 
      v-if="!showOnlyTotal"
      :list="dailyRowsWithTotal" 
      
      :titles="{
        'summary_date' : 'Date',
        'litres' : 'Total<br>Litres',
        'dollars' : 'Total<br>Dollars',
        'count' : 'Transactions',
        'pap_litres' : 'P@P<br>Litres',
        'pap_dollars' : 'P@P<br>Dollars',
        'pap_count' : 'P@P<br>Count',
        'instore_litres' : 'In Store<br>Litres',
        'instore_dollars' : 'In Store<br>Dollars',
        'instore_count' : 'In Store<br>Count',
      }" 
      
    />
    
    <!-- Monthly Total Table - Always shows the total row -->
    <table style="width:400px">
      <tr>
        <!-- Month,Total Litres,Total Dollars,Transactions,P@P Litres,P@P Dollars,P@P Count,Store Litres,Store Dollars,Store Count  -->
        <th>Period</th>
        <th>Total Litres</th>
        <th>Total Dollars</th>
        <th>Transactions</th>
        <th>P@P Litres</th>
        <th>P@P Dollars</th>
        <th>P@P Count</th>
        <th>In Store Litres</th>
        <th>In Store Dollars</th>
        <th>In Store Count</th>
      </tr>
      
      <tr v-if="!fuelStore.data[location].isLoading && totalRow" :style="{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }">
        <td style="text-align:right">{{D(totalRow.ts_from, 'MMM-YYYY')}}</td>
        <td style="text-align:right">{{F(totalRow.litres)}}</td>
        <td style="text-align:right">{{F(totalRow.dollars)}}</td>
        <td style="text-align:right">{{F(totalRow.count, '0,0')}}</td>
        <td style="text-align:right">{{F(totalRow.pap_litres)}}</td>
        <td style="text-align:right">{{F(totalRow.pap_dollars)}}</td>
        <td style="text-align:right">{{F(totalRow.pap_count, '0,0')}}</td>
        <td style="text-align:right">{{F(totalRow.instore_litres)}}</td>
        <td style="text-align:right">{{F(totalRow.instore_dollars)}}</td>
        <td style="text-align:right">{{F(totalRow.instore_count, '0,0')}}</td>
      </tr>
    </table>
  </div>


</template>

<script>
import formatDataMixin from '@/mixins/formatDataMixin.js'
export default {
  
  inject: ['payAtPumpPage'],
  props: ['location'],
  mixins : [formatDataMixin],
  computed:{
    fuelStore(){
      return this.payAtPumpPage.$refs.fuelStore
    },
    fuelData(){
      return this.fuelStore.data && this.fuelStore.data[this.location] ? this.fuelStore.data[this.location].fuel : undefined;
    },
    isLoading(){
      return this.fuelStore[this.location].isLoading;
    },
    showOnlyTotal(){
      return this.payAtPumpPage.showOnlyTotal;
    },
    dailyRows(){
      if (!this.fuelData || !Array.isArray(this.fuelData)) return [];
      // Return all rows except the last one (which is the total)
      return this.fuelData.slice(0, -1);
    },
    dailyRowsWithTotal(){
      if (!this.fuelData || !Array.isArray(this.fuelData)) return [];
      // Return all rows including the total for the BasicTableComponent
      return this.fuelData;
    },
    totalRow(){
      if (!this.fuelData || !Array.isArray(this.fuelData)) return null;
      // Return the last row which should be the total
      const lastRow = this.fuelData[this.fuelData.length - 1];
      return lastRow && lastRow.summary_date === 'Total' ? lastRow : null;
    }
  },
  methods: {
    // No additional methods needed
  }
  

}
</script>

<style lang="scss" scoped>

</style>